import { editorComponents, componentList } from "../components/ComponentRegistry.js";
import { FloatingWindow } from "./floatingwindow.js";
import { componentStringSchema } from "../decorators/type.js";
import lodash from "lodash";
import { D as DescriptionSchema } from "../Description-c36d0b9a.js";
import { A as AttachSchema } from "../Attach-abbbd93e.js";
import "../components/types.js";
import "../enums-86f58524.js";
import "../utils/byteArray.js";
import "../global-33d5eebf.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../utils/vector.js";
let currentEditor = null;
let JSONEditor = class {
};
if (typeof window !== "undefined") {
  (async () => {
    JSONEditor = (await import("../jsoneditor-cec6a045.js").then((n) => n.j)).JSONEditor;
  })();
}
const editor = (entity, gameModel) => {
  if (currentEditor) {
    currentEditor.close();
  }
  currentEditor = Editor(entity, gameModel);
};
const stringToObj = function(path, obj, value) {
  const parts = path.split(".");
  let part;
  const last = parts.pop();
  while (part = parts.shift()) {
    if (typeof obj[part] != "object")
      obj[part] = {};
    obj = obj[part];
  }
  if (value === void 0) {
    return obj[last];
  } else {
    obj[last] = value;
  }
};
const Editor = (entity, gameModel) => {
  if (typeof entity === "string") {
    entity = parseInt(entity);
  }
  const editorContainer = document.createElement("div");
  editorContainer.id = "editor";
  const contentContainer = document.createElement("div");
  contentContainer.id = "editor-content";
  const jsonEditorContainer = document.createElement("div");
  jsonEditorContainer.id = "json-editor";
  const logEntity = document.createElement("button");
  logEntity.innerText = "Log Entity";
  logEntity.onclick = () => {
    console.log("LOG ENTITY");
    gameModel.logEntity(entity, true);
  };
  const addComponentDropdown = document.createElement("select");
  addComponentDropdown.id = "add-component-dropdown";
  const addComponentButton = document.createElement("button");
  addComponentButton.innerText = "Add Component";
  const removeComponent = document.createElement("button");
  removeComponent.style.display = "none";
  editorContainer.appendChild(logEntity);
  editorContainer.appendChild(addComponentDropdown);
  editorContainer.appendChild(addComponentButton);
  editorContainer.appendChild(contentContainer);
  editorContainer.appendChild(removeComponent);
  editorContainer.appendChild(jsonEditorContainer);
  let state = "summary";
  let customComponentUI = null;
  let editedComponent = null;
  let activeJsonEditor = null;
  let selectedComponent = null;
  removeComponent.innerText = "Remove Component";
  removeComponent.onclick = () => {
    if (!selectedComponent)
      return;
    gameModel.removeComponent(entity, selectedComponent);
    activeJsonEditor == null ? void 0 : activeJsonEditor.destroy();
    activeJsonEditor = null;
    editedComponent = null;
    selectedComponent = null;
  };
  addComponentButton.onclick = () => {
    const component = addComponentDropdown.value;
    gameModel.addComponent(entity, component);
    editedComponent = component;
    selectedComponent = component;
    state = "component";
  };
  contentContainer.addEventListener("click", (e) => {
    var _a;
    console.log(e.target);
    const dataset = (_a = e.target) == null ? void 0 : _a.dataset;
    if (dataset) {
      if (dataset.select) {
        selectedComponent = dataset.select;
      }
      if (dataset.customcomponent) {
        state = "component";
        customComponentUI = dataset.customcomponent ?? null;
      } else if (dataset.entity) {
        customComponentUI = null;
        editedComponent = null;
        activeJsonEditor == null ? void 0 : activeJsonEditor.destroy();
        activeJsonEditor = null;
        entity = parseInt(dataset.entity);
        state = "summary";
      } else if (dataset.edit) {
        editedComponent = dataset.edit;
        const componentSchema = componentStringSchema.get(editedComponent);
        if (activeJsonEditor) {
          activeJsonEditor.destroy();
        }
        activeJsonEditor = new JSONEditor(jsonEditorContainer, {
          // @ts-ignore
          schema: componentSchema.__schema
        });
        activeJsonEditor.on("ready", () => {
          if (!editedComponent)
            return;
          activeJsonEditor == null ? void 0 : activeJsonEditor.setValue(gameModel.getComponent(entity, editedComponent));
        });
        activeJsonEditor.on("change", () => {
          const value = activeJsonEditor == null ? void 0 : activeJsonEditor.getValue();
          if (!dataset.edit)
            return;
          gameModel.addComponent(entity, dataset.edit, value, true);
        });
      }
    }
  });
  const refresh = () => {
    if (!editedComponent)
      return;
    const value = gameModel.getComponent(entity, editedComponent);
    if (!lodash.isEqual(value, activeJsonEditor == null ? void 0 : activeJsonEditor.getValue())) {
      const editors = activeJsonEditor == null ? void 0 : activeJsonEditor.editors;
      const keys = Object.keys(editors).map((key) => key.substring(5)).filter((key) => key !== "");
      for (const key of keys) {
        const editor2 = editors["root." + key];
        if (editor2) {
          const val = stringToObj(key, value);
          if (editor2.value !== val) {
            editor2.setValue(val);
            editor2.refreshValue();
          }
        }
      }
    }
  };
  const updateComponentDropdown = (inactiveComponents) => {
    addComponentDropdown.innerHTML = "";
    for (const component of inactiveComponents) {
      const option = document.createElement("option");
      option.value = component;
      option.innerText = component;
      addComponentDropdown.appendChild(option);
    }
  };
  let previousInactiveComponentStrings = [];
  const generateSummary = () => {
    const entityData = gameModel.state.entityComponentArray[entity];
    if (!entityData) {
      return `<div>Entity ${entity} does not exist</div>`;
    }
    const { inactiveComponents, activeComponents } = componentList.reduce(
      (acc, component, i) => {
        if (entityData.get(i)) {
          acc.activeComponents.push(component);
        } else {
          acc.inactiveComponents.push(component);
        }
        return acc;
      },
      { inactiveComponents: [], activeComponents: [] }
    );
    const inactiveComponentStrings = inactiveComponents.map((component) => component.type).sort();
    if (!lodash.isEqual(inactiveComponentStrings, previousInactiveComponentStrings)) {
      updateComponentDropdown(inactiveComponentStrings);
      previousInactiveComponentStrings = inactiveComponentStrings;
    }
    const generateHeader = () => {
      let prev = "";
      if (gameModel.hasComponent(entity, AttachSchema)) {
        const parentId = gameModel.getTypedUnsafe(entity, AttachSchema).parent;
        if (parentId != void 0) {
          prev = `<span data-entity="${parentId}">Parent</span>`;
        }
      }
      if (gameModel.hasComponent(entity, DescriptionSchema)) {
        const description = gameModel.getTypedUnsafe(entity, DescriptionSchema).description;
        return `${prev}<h1>Entity: ${entity} - ${description}</h1>`;
      }
      return `${prev}<h1>Entity: ${entity}</h1>`;
    };
    const nextHtml = `
      ${generateHeader()}
      <h2>Components</h2>
      <ul>
        ${activeComponents.sort((a, b) => a.type.localeCompare(b.type)).map((component) => {
      if (!component.schema) {
        return `<li data-select="${component.type}">${component.type}</li>`;
      }
      if (editorComponents[component.type]) {
        return `<li data-select="${component.type}" data-customcomponent="${component.type}">${component.type}</li>`;
      }
      return `<li data-select="${component.type}" data-edit="${component.type}">${component.type}</li>`;
    }).join("")}
      </ul>
    `;
    if (nextHtml !== contentContainer.innerHTML) {
      contentContainer.innerHTML = nextHtml;
    }
  };
  const floater = new FloatingWindow(editorContainer);
  generateSummary();
  const close = () => {
    floater.close();
    if (activeJsonEditor) {
      activeJsonEditor.destroy();
    }
    clearInterval(inter);
  };
  const inter = setInterval(() => {
    if (!gameModel.isActive(entity)) {
      close();
      return;
    }
    removeComponent.style.display = selectedComponent ? "block" : "none";
    generateSummary();
    if (state === "component" && customComponentUI) {
      editorComponents[customComponentUI].system(contentContainer, entity, gameModel);
    }
    if (activeJsonEditor) {
      refresh();
    }
  }, 100);
  return {
    close
  };
};
export {
  editor
};
//# sourceMappingURL=editor.js.map
